import styled, { css } from 'styled-components'
import { colors } from 'client/styles'
import { InputRadio, LabelRadio } from 'client/components/InputLine/styles'

const BaseWithBorder = css`
  border-radius: 8px;
  border: 2px solid ${colors.grey1};
  padding-block: 12px;
  padding-inline: 12px;
`

export const CreditCardInfoBase = styled.div`
  font-size: 16px;
  ${props => props.withBorder && BaseWithBorder};

  ${InputRadio} {
    margin-inline-end: 12px;
    &:checked {
      background-color: ${colors.grey1};
      &::after {
        background-color: ${colors.grey1};
      }
    }
  }

  ${LabelRadio} {
    color: ${colors.grey1};
    align-items: flex-start;
  }
`

export const CreditCardWrapper = styled.div`
  display: flex;
  flex-direction: column;
  color: ${colors.grey1};
  font-weight: 700;
  font-size: 16px;
  line-height: 150%;

  svg {
    fill: ${colors.grey1};
  }
`

export const Number = styled.div`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  padding-block-end: 4px;
`

export const Brand = styled.div`
  margin-inline: 8px;
  margin-block: 0;
  text-transform: capitalize;
`

export const CreditCardNumber = styled.span`
  line-height: 150%;
`

export const CreditCardNumberMask = styled.span`
  font-weight: 500;
`

export const Holder = styled.div`
  padding-block-end: 4px;
`

export const ExpiringDate = styled.div`
  font-size: 14px;

  span {
    color: ${colors.grey2};
  }
`
